import React, { memo } from 'react';
import { StickyHeader as ManorStickyHeader } from '@comparethemarketau/manor-header';
import { DynamicComponent } from '../dynamic_component/dynamic_component';
import BrandedLogo from './branded_logo';

const StickyHeader = memo((props) => {
    return <DynamicComponent component={<ManorStickyHeader {...props} logo={<BrandedLogo />} />} />;
});

export { StickyHeader };
